import axios, { addInterceptors } from './interceptor-axios';
import config from '~/config';

class AuthService {
  constructor(token) {
    const headers = {};
    if (token) {
      headers.Authorization = token;
    }
    this.axios = axios.create({
      baseURL: config.apiUserURL,
      headers,
    });
    addInterceptors(this.axios);
  }

  login = () => {
    console.log('--- login service ---');
    const request = {
      method: 'GET',
      url: '/',
      params: {
        serviceURL: 'http://local.editor-ac.com/',
      },
    };
    console.log(request);
    return this.axios(request);
  };

  saveUser = (userInfo) => {
    const request = {
      method: 'POST',
      url: '/add/user',
      data: {
        user_id: userInfo.user_id,
        email: userInfo.email,
        nick_name: userInfo.nick_name,
        avatar: userInfo.avatar,
        role_id: (userInfo.premium_info && typeof userInfo.premium_info === 'object') ? 2 : 1
      },
    };
    console.log(request);
    return this.axios(request);
  };
}

export default new AuthService();
